export const getBreadcrumbs = (title) => [
  { text: 'Invoices', to: '../invoices' },
  { text: title },
];

export const populateAmount = (lineItem) => ({
  ...lineItem,
  amount: Number((lineItem.quantity * lineItem.unitPrice).toFixed(2)),
});
